import { render, staticRenderFns } from "./QuoteTemplateSettingMenu.vue?vue&type=template&id=628c398c"
import script from "./QuoteTemplateSettingMenu.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateSettingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('628c398c')) {
      api.createRecord('628c398c', component.options)
    } else {
      api.reload('628c398c', component.options)
    }
    module.hot.accept("./QuoteTemplateSettingMenu.vue?vue&type=template&id=628c398c", function () {
      api.rerender('628c398c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateSettingMenu.vue"
export default component.exports